import { Link } from "react-router-dom";
import { Icon } from "@/components/Icon";

const base =
  "group inline-flex items-center justify-center gap-2 rounded-[4px] px-7 py-3 text-[15px] font-medium tracking-[0.01em] font-body transition-[background-color,color,box-shadow,transform,border-color] duration-200 ease-out will-change-transform hover:-translate-y-[1px] active:translate-y-0";

const styles = {
  primary:
    "bg-[#2A2E7A] text-white shadow-sm hover:bg-[#1E2160] hover:shadow-md",
  secondary:
    "bg-white text-[#2A2E7A] border border-[#2A2E7A]/25 hover:border-[#2A2E7A] hover:bg-[#2A2E7A] hover:text-white hover:shadow-md",
  accent:
    "bg-[#4B5CAB] text-white shadow-sm hover:bg-[#3C4C93] hover:shadow-md",
  ghost:
    "bg-transparent text-[#2A2E7A] hover:text-[#4B5CAB] hover:-translate-y-0",
};

// Static UI button. Renders a react-router Link when `to` is provided.
export const Cta = ({
  children,
  to,
  href,
  variant = "primary",
  className = "",
  withArrow = false,
  testId,
  ...rest
}) => {
  const cls = `${base} ${styles[variant]} ${className}`;
  const content = (
    <>
      {children}
      {withArrow && (
        <Icon
          name="ArrowRight"
          className="h-4 w-4 transition-transform duration-200 ease-out group-hover:translate-x-0.5"
        />
      )}
    </>
  );

  if (to) {
    return (
      <Link to={to} className={cls} data-testid={testId} {...rest}>
        {content}
      </Link>
    );
  }
  if (href) {
    return (
      <a href={href} className={cls} data-testid={testId} {...rest}>
        {content}
      </a>
    );
  }
  return (
    <button className={cls} data-testid={testId} {...rest}>
      {content}
    </button>
  );
};

export default Cta;
